import React, {useRef, useState} from 'react';
import {Button, Col, Upload} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';

import {createCarImage, deleteCarImage} from '../../helpers/car';
import {messageType, showMessages} from '../../helpers/message';

import './CarImageUpload.less';
import {useAppDispatch} from '../../hooks/useStore';
import {apiSlice} from '../../store/api/apiSlice';

const CarImageUpload = ({car}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);
    const dispatch = useAppDispatch();

    const [uploadLoading, setUploadLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleUpload = async (props) => {
        const abortSignal = abortSignalRef.current;
        setUploadLoading(true);

        try {
            await createCarImage(car.id, props.file, abortSignal);
            showMessages('Vehicle image successfully uploaded.', messageType.success)
            setUploadLoading(false);
        } catch (error) {
            showMessages(error.message, messageType.error)
            setUploadLoading(false);
        }

        // Temp invalidate Car until refactored to use RTK.
        dispatch(apiSlice.util.invalidateTags([{type: 'Car', id: car.id}]));
    };

    const handleDelete = async () => {
        const abortSignal = abortSignalRef.current;
        setDeleteLoading(true);

        try {
            await deleteCarImage (car.id, abortSignal);
            showMessages('Vehicle image successfully removed.', messageType.success)
            setDeleteLoading(false);
        } catch (error) {
            showMessages(error.message, messageType.error)
            setDeleteLoading(false);
        }

        // Temp invalidate Car until refactored to use RTK.
        dispatch(apiSlice.util.invalidateTags([{type: 'Car', id: car.id}]));
    };

    const uploadProps = {
        name: 'image',
        customRequest: handleUpload,
        showUploadList: false,
    };

    return (
        <Col xs={24} md={8} className='car-image-button-wrapper'>
            <Upload {...uploadProps}>
                <Button loading={uploadLoading} icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
            <>
                <Button loading={deleteLoading} onClick={handleDelete}>Remove Image</Button>
            </>
        </Col>
    )
};

export default CarImageUpload;

CarImageUpload.propTypes = {
    car: PropTypes.object.isRequired,
};
